// import { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import swal from "sweetalert";
// import {
//   CButton,
//   CCard,
//   CCardBody,
//   CCardHeader,
//   CCol,
//   CForm,
//   CFormInput,
//   CFormFeedback,
//   CFormLabel,
//   CFormSelect,
//   CFormTextarea,
//   CInputGroup,
//   CRow,
//   CHeaderDivider,
//   CBreadcrumb,
//   CBreadcrumbItem
// } from "@coreui/react";
// import { fetchCustomerListApi } from "../Helper/order";
// import { useSelector } from "react-redux";
// import { customerApi } from "../Helper/customer";
// import { useParams } from "react-router-dom";
// import { orderEditByIdApi } from "../Helper/order";
// import Select from "react-select";

// function View() {
//   const [image, setImage] = useState(null);
//   const [preview, setPreview] = useState();
//   const [formFields, setFormFields] = useState([
//     { item: "", charges: "", type: "" },
//   ]);

//   const [orderItems, setOrderItems] = useState([]);
//   const [customernameError, setCustomernameError] = useState(false);
//   const [chargestotal, setchargestotal] = useState();
//   const [customerlist, setCustomerList] = useState([]);
//   const [validated, setValidated] = useState(false);
//   const [note, setNote] = useState("");
//   const [Date, setDate] = useState();
//   const [selectedCustomer, setSelectedCusomer] = useState();
//   const [OrderPhoto, setOrderPhoto] = useState();
//   const [customerName, setCustomerName] = useState("");

//   let { Id } = useParams();

//   useEffect(() => {
//     getorderDataForEdit();
//   }, []);

//   useEffect(() => {
//     if (!image) {
//       setPreview(undefined);
//       return;
//     }
//     const objectUrl = URL.createObjectURL(image);
//     if (image.type === "image/png" || image.type === "image/jpeg") {
//       setPreview(objectUrl);
//     } else {
//       setPreview(null);
//     }
//     return () => URL.revokeObjectURL(objectUrl);
//   }, [image]);

//   const handleFormChange = (event, index) => {
//     let data = [...formFields];
//     data[index][event.target.name] = event.target.value;
//     setFormFields(data);
//     if (event.target.name == "charges") {
//       let totalcharges = 0;
//       formFields.map((e) => {
//         totalcharges = totalcharges + parseFloat(e.charges);
//       });
//       setchargestotal(totalcharges);
//     }
//   };

//   const getorderDataForEdit = async () => {
//     let orderId = Id;
//     await orderEditByIdApi(orderId)
//       .then((res) => {
//         if (res.status === 200) {
//           console.log("API Response:", res.data);
//           console.log("First order item:", res.data.orderItems[0]);

//           setOrderItems(res.data.orderItems);
//           setCustomerName(res.data.customerName);

//           var items = [];
//           res.data.orderItems.forEach((element) => {
//             items.push({
//               item: element.item,
//               type: element.type,
//               charges: element.charges,
//               isComplete: element.isComplete === 1 ? "1" : "0",
//               isSent: element.isSent === 1 ? "1" : "0",
//               isReceived: element.isReceived === 1 ? "1" : "0",
//               isReturn: element.isReturn === 1 ? "1" : "0",
//               receivedBy: element.receivedBy || "",
//               sentDate: element.sentDate || ""
//             });
//           });
//           setFormFields(items);

//           setNote(res.data.note);
//           const apiDate = res.data.orderDate;
//           const dateOnly = apiDate.split(' ')[0];
//           setDate(dateOnly);

//           setSelectedCusomer({
//             value: res?.data?.customerId,
//             label: res?.data?.customerName,
//           });
//           setchargestotal(res.data.totalCharges);
//           setOrderPhoto(res.data.orderPhoto);
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching order data:", err);
//       });
//   };

//   function handleCustomer(e) {
//     setSelectedCusomer(e.value);
//     setCustomernameError("");
//   }

//   return (
//     <div>
//       <CHeaderDivider />

//       <CRow className="m-2 mb-0">
//         <CCol xs={12}>
//           <h5 className="main-title">View </h5>
//         </CCol>
//         <CCol xs={8}>
//           <CBreadcrumb
//             className="m-0 ms-2"
//             style={{ "--cui-breadcrumb-divider": "'>'" }}
//           >
//             <CBreadcrumbItem>
//               <Link to="/dashboard">Home</Link>
//             </CBreadcrumbItem>
//             <CBreadcrumbItem actives>View Order</CBreadcrumbItem>
//           </CBreadcrumb>
//         </CCol>
//         <CCol xs={4}>
//           <div className="text-end">
//             <CButton
//               color="info"
//               size="sm"
//               className="px-4 text-end text-white "
//               type="button"
//               style={{ marginTop: "-52px" }}
//               onClick={() => window.history.back()}
//             >
//               Back
//             </CButton>
//           </div>
//         </CCol>
//       </CRow>

//       <br />

//       <CRow className="justify-content-start">
//         <CCol md={12} sm={12} lg={12}>
//           <CCard style={{ margin: "10px" }} className="mb-4">
//             <CCardHeader>
//               <strong>View Order Details</strong>
//             </CCardHeader>
//             <CCardBody>
//               <br />
//               <div>
//                 <CForm
//                   className="row g-3 needs-validation"
//                   noValidate
//                   validated={validated}
//                   method="post"
//                 >
//                   <CRow className="mb-3">
//                     <CCol md={7} sm={12} xs={12}>
//                       <CFormLabel>Customer</CFormLabel>
//                       <div className="">
//                         <Select
//                           options={customerlist}
//                           isDisabled={true}
//                           className="text-start"
//                           placeholder={
//                             <div className="select-placeholder-text">
//                               Select options
//                             </div>
//                           }
//                           value={selectedCustomer}
//                           onChange={handleCustomer}
//                           isSearchable={true}
//                         />
//                       </div>
//                     </CCol>
//                     <CCol md={1} sm={1} xs={2}></CCol>

//                     <CCol lg={3} md={6} sm={5}>
//                       <CFormLabel>Order Date</CFormLabel>
//                       <CInputGroup className="mb-3">
//                         <CFormInput
//                           type="text"
//                           name="date"
//                           className="text-dark"
//                           value={Date || ""}
//                           disabled
//                           placeholder="Order Date & Time"
//                         />
//                       </CInputGroup>
//                     </CCol>
//                   </CRow>

//                   <CCol md={12} sm={12} xs={12}>
//                     <CCardHeader className="header-item">
//                       <strong>Order Items</strong>
//                     </CCardHeader>
//                   </CCol>
//                   <br />
//                   <br />

//                   {formFields.map((form, index) => {
//                     return (
//                       <div className="item-background mb-3 p-3" key={index}>
//                         <CRow>
//                           <CCol md={4} sm={12} xs={12} className="input-item">
//                             <CFormLabel className="mb-3">Item :</CFormLabel>
//                             <CFormInput
//                               type="text"
//                               value={form.item}
//                               disabled
//                               className="bg-light"
//                             />
//                           </CCol>

//                           <CCol md={3} sm={12} xs={12} className="type-input">
//                             <CFormLabel className="mb-3">Type :</CFormLabel>
//                             <CFormSelect
//                               disabled
//                               className="bg-light"
//                               value={form.type}
//                             >
//                               <option value="">Choose</option>
//                               <option value="gold">Gold</option>
//                               <option value="silver">Silver</option>
//                             </CFormSelect>
//                           </CCol>

//                           <CCol md={2} sm={12} xs={12} className="Charges-input">
//                             <CFormLabel className="mb-3">Charges :</CFormLabel>
//                             <CFormInput
//                               type="number"
//                               value={form.charges}
//                               disabled
//                               className="bg-light"
//                             />
//                           </CCol>

//                           {/* Received By Section - Only show if item is sent */}
//                           {form.isSent === "1" && (
//                             <CCol md={2} sm={12} xs={12} className="received-by-input">
//                               <CFormLabel className="mt-2">
//                                 Received By (Item-wise)
//                               </CFormLabel>
//                               <CFormInput
//                                 type="text"
//                                 value={form.receivedBy || customerName || "Not specified"}
//                                 disabled
//                                 className="bg-light"
//                               />
//                               {form.sentDate && (
//                                 <small className="text-muted d-block">

//                                 </small>
//                               )}
//                             </CCol>
//                           )}
//                         </CRow>

//                         <CRow className="mt-3">
//                           <CCol md={12} sm={12} xs={12}>
//                             <CRow>
//                               <CCol md={2} sm={4} xs={6} className="text-complet-checkbox">
//                                 <div className="form-check">
//                                   <CFormLabel className="label-check-edit">
//                                     Is Complete
//                                   </CFormLabel>
//                                   <input
//                                     className="form-check-input"
//                                     style={{
//                                       fontSize: "20px",
//                                       marginLeft: "-20px",
//                                     }}
//                                     type="checkbox"
//                                     checked={form.isComplete === "1"}
//                                     disabled
//                                     readOnly
//                                   />
//                                 </div>
//                               </CCol>

//                               <CCol md={2} sm={4} xs={6} className="text-complet-checkbox">
//                                 <div className="form-check">
//                                   <CFormLabel className="label-check-edit">
//                                     Is Sent
//                                   </CFormLabel>
//                                   <input
//                                     className="form-check-input"
//                                     style={{ fontSize: "20px", marginLeft: "-20px" }}
//                                     type="checkbox"
//                                     checked={form.isSent === "1"}
//                                     disabled
//                                     readOnly
//                                   />
//                                 </div>
//                               </CCol>

//                               <CCol md={2} sm={4} xs={6} className="text-complet-checkbox">
//                                 <div className="form-check">
//                                   <CFormLabel className="label-check-edit">
//                                     Is Returned
//                                   </CFormLabel>
//                                   <input
//                                     className="form-check-input"
//                                     style={{
//                                       fontSize: "20px",
//                                       marginLeft: "-20px",
//                                     }}
//                                     type="checkbox"
//                                     checked={form.isReturn === "1"}
//                                     disabled
//                                     readOnly
//                                   />
//                                 </div>
//                               </CCol>

//                               <CCol md={2} sm={4} xs={6} className="text-complet-checkbox">
//                                 <div className="form-check">
//                                   <CFormLabel className="label-check-edit">
//                                     Is Received
//                                   </CFormLabel>
//                                   <input
//                                     className="form-check-input"
//                                     style={{
//                                       fontSize: "20px",
//                                       marginLeft: "-20px",
//                                     }}
//                                     type="checkbox"
//                                     checked={form.isReceived === "1"}
//                                     disabled
//                                     readOnly
//                                   />
//                                 </div>
//                               </CCol>
//                             </CRow>
//                           </CCol>
//                         </CRow>
//                       </div>
//                     );
//                   })}

//                   <CRow className="mt-3">
//                     <CCol md={8} sm={12} xs={12}></CCol>
//                     <CCol lg={3} md={12} sm={12} xs={12}>
//                       <CFormLabel htmlFor="validationCustom03">
//                         Total Charges :
//                       </CFormLabel>
//                       <CFormInput
//                         type="number"
//                         id="validationCustom03"
//                         disabled
//                         className="bg-light"
//                         name="total_number"
//                         value={chargestotal}
//                         placeholder="Total"
//                       />
//                     </CCol>
//                   </CRow>

//                   <CRow className="mt-3">
//                     <CForm>
//                       <CCol md={8} sm={12} xs={12}>
//                         <CFormLabel htmlFor="exampleFormControlTextarea1">
//                           Note
//                         </CFormLabel>
//                         <CFormTextarea
//                           id="exampleFormControlTextarea1"
//                           name="note"
//                           rows={3}
//                           text=""
//                           disabled
//                           className="bg-light"
//                           onChange={(e) => setNote(e.target.value)}
//                           value={note}
//                         ></CFormTextarea>
//                       </CCol>
//                     </CForm>
//                   </CRow>

//                   <CRow className="mt-3">
//                     <CCol md={7} sm={12} xs={12}>
//                       <CFormLabel htmlFor="validationCustom02">
//                         {OrderPhoto &&
//                           OrderPhoto != "" &&
//                           OrderPhoto != "No Image" ? "Order Image" : ""}
//                       </CFormLabel>
//                     </CCol>
//                   </CRow>
//                   <CCol xs={12}>
//                     {preview ? (
//                       <img src={preview} className="imagePreview" alt="Preview" />
//                     ) : OrderPhoto &&
//                       OrderPhoto != "" &&
//                       OrderPhoto != "No Image" ? (
//                       <img src={OrderPhoto} className="imagePreview" alt="Order" />
//                     ) : null}
//                   </CCol>
//                 </CForm>
//               </div>
//             </CCardBody>
//           </CCard>
//         </CCol>
//       </CRow>
//     </div>
//   );
// }

// export default View;

import {
  CBreadcrumb,
  CBreadcrumbItem,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CHeaderDivider,
  CInputGroup,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { orderEditByIdApi } from "../Helper/order";

function View() {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState();
  const [formFields, setFormFields] = useState([
    { item: "", charges: "", type: "" },
  ]);

  const [orderItems, setOrderItems] = useState([]);
  const [customernameError, setCustomernameError] = useState(false);
  const [chargestotal, setchargestotal] = useState();
  const [customerlist, setCustomerList] = useState([]);
  const [validated, setValidated] = useState(false);
  const [note, setNote] = useState("");
  const [Date, setDate] = useState();
  const [selectedCustomer, setSelectedCusomer] = useState();
  const [OrderPhoto, setOrderPhoto] = useState();
  const [customerName, setCustomerName] = useState("");
  const [customerExtraText, setCustomerExtraText] = useState(""); // Added


  let { Id } = useParams();

  useEffect(() => {
    getorderDataForEdit();
  }, []);

  useEffect(() => {
    if (!image) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(image);
    if (image.type === "image/png" || image.type === "image/jpeg") {
      setPreview(objectUrl);
    } else {
      setPreview(null);
    }
    return () => URL.revokeObjectURL(objectUrl);
  }, [image]);

  const handleFormChange = (event, index) => {
    let data = [...formFields];
    data[index][event.target.name] = event.target.value;
    setFormFields(data);
    if (event.target.name == "charges") {
      let totalcharges = 0;
      formFields.map((e) => {
        totalcharges = totalcharges + parseFloat(e.charges);
      });
      setchargestotal(totalcharges);
    }
  };

  const getorderDataForEdit = async () => {
    let orderId = Id;
    await orderEditByIdApi(orderId)
      .then((res) => {
        if (res.status === 200) {
          setOrderItems(res.data.orderItems);
          setCustomerName(res.data.customerName);
          setCustomerExtraText(res.data.customerReference || ""); // Added

          var items = [];
          res.data.orderItems.forEach((element) => {
            items.push({
              item: element.item,
              type: element.type,
              charges: element.charges,
              isComplete: element.isComplete === 1 ? "1" : "0",
              isSent: element.isSent === 1 ? "1" : "0",
              isReceived: element.isReceived === 1 ? "1" : "0",
              isReturn: element.isReturn === 1 ? "1" : "0",
              receivedBy: element.receivedBy || "",
              sentDate: element.sentDate || "",
            });
          });
          setFormFields(items);

          // Auto-fill receivedBy with customerName for sent items if not provided by API
          // This ensures consistency between creation, edit, and view modes
          // Note: Similar logic applied in OrderTable/index.js getorderDataForEdit
          const updatedItems = items.map((item) => {
            if (item.isSent === "1" && (!item.receivedBy || item.receivedBy.trim() === "")) {
              return {
                ...item,
                receivedBy: res.data.customerName,
              };
            }
            return item;
          });
          setFormFields(updatedItems);

          setNote(res.data.note);
          const apiDate = res.data.orderDate;
          const dateOnly = apiDate.split(" ")[0];
          setDate(dateOnly);

          setSelectedCusomer({
            value: res?.data?.customerId,
            label: res?.data?.customerName,
          });
          setchargestotal(res.data.totalCharges);
          setOrderPhoto(res.data.orderPhoto);
        }
      })
      .catch((err) => {
        console.error("Error fetching order data:", err);
      });
  };

  function handleCustomer(e) {
    setSelectedCusomer(e.value);
    setCustomernameError("");
  }

  return (
    <div>
      <CHeaderDivider />

      <CRow className="m-2 mb-0">
        <CCol xs={12}>
          <h5 className="main-title">View </h5>
        </CCol>
        <CCol xs={8}>
          <CBreadcrumb
            className="m-0 ms-2"
            style={{ "--cui-breadcrumb-divider": "'>'" }}
          >
            <CBreadcrumbItem>
              <Link to="/dashboard">Home</Link>
            </CBreadcrumbItem>
            <CBreadcrumbItem actives>View Order</CBreadcrumbItem>
          </CBreadcrumb>
        </CCol>
        <CCol xs={4}>
          <div className="text-end">
            <CButton
              color="info"
              size="sm"
              className="px-4 text-end text-white "
              type="button"
              style={{ marginTop: "-52px" }}
              onClick={() => window.history.back()}
            >
              Back
            </CButton>
          </div>
        </CCol>
      </CRow>

      <br />

      <CRow className="justify-content-start">
        <CCol md={12} sm={12} lg={12}>
          <CCard style={{ margin: "10px" }} className="mb-4">
            <CCardHeader>
              <strong>View Order Details</strong>
            </CCardHeader>
            <CCardBody>
              <br />
              <div>
                <CForm
                  className="row g-3 needs-validation"
                  noValidate
                  validated={validated}
                  method="post"
                >
                  <CRow className="mb-3">
                    <CCol md={5} sm={12} xs={12}>
                      <CFormLabel>Customer</CFormLabel>
                      <div className="">
                        <Select
                          options={customerlist}
                          isDisabled={true}
                          className="text-start"
                          placeholder={
                            <div className="select-placeholder-text">
                              Select options
                            </div>
                          }
                          value={selectedCustomer}
                          onChange={handleCustomer}
                          isSearchable={true}
                        />
                      </div>
                    </CCol>

                    <CCol md={4} sm={12} xs={12}>
                      <CFormLabel>Customer Reference</CFormLabel>
                      <CFormInput
                        type="text"
                        value={customerExtraText}
                        disabled
                        className="bg-light"
                        placeholder="No reference"
                      />
                    </CCol>

                    <CCol md={3} sm={12} xs={12}>
                      <CFormLabel>Order Date</CFormLabel>
                      <CInputGroup className="mb-3">
                        <CFormInput
                          type="text"
                          name="date"
                          className="text-dark bg-light"
                          value={Date || ""}
                          disabled
                          placeholder="Order Date & Time"
                        />
                      </CInputGroup>
                    </CCol>
                  </CRow>

                  <CCol md={12} sm={12} xs={12}>
                    <CCardHeader className="header-item">
                      <strong>Order Items</strong>
                    </CCardHeader>
                  </CCol>
                  <br />
                  <br />

                  {formFields.map((form, index) => {
                    return (
                      <div className="item-background mb-3 p-3" key={index}>
                        <CRow>
                          {/* <CCol md={4} sm={12} xs={12} className="input-item">
                            <CFormLabel className="mb-3">Item :</CFormLabel>
                            <CFormInput
                              type="text"
                              value={form.item}
                              disabled
                              className="bg-light"
                            />
                          </CCol> */}

                          <CCol md={4} sm={12} xs={12} className="input-item">
                            <CFormLabel className="mb-3">
                              Item {index + 1} :
                            </CFormLabel>
                            <CFormInput
                              type="text"
                              title={form.item}
                              value={form.item}
                              disabled
                              className="bg-light"
                            />
                          </CCol>

                          <CCol md={3} sm={12} xs={12} className="type-input">
                            <CFormLabel className="mb-3">Type :</CFormLabel>
                            <CFormSelect
                              disabled
                              className="bg-light"
                              value={form.type}
                            >
                              <option value="">Choose</option>
                              <option value="gold">Gold</option>
                              <option value="silver">Silver</option>
                              <option value="1gm">1 Gram</option>
                            </CFormSelect>
                          </CCol>

                          <CCol
                            md={2}
                            sm={12}
                            xs={12}
                            className="Charges-input"
                          >
                            <CFormLabel className="mb-3">Charges :</CFormLabel>
                            <CFormInput
                              type="number"
                              value={form.charges}
                              disabled
                              className="bg-light"
                            />
                          </CCol>

                          {/* Received By Section - Always show for consistency */}
                          <CCol
                            md={3}
                            sm={12}
                            xs={12}
                            className="received-by-input"
                          >
                            <CFormLabel className="mt-2">
                              Received By (Item-wise)
                            </CFormLabel>
                            <CFormInput
                              type="text"
                              value={form.receivedBy || ""}
                              disabled
                              className="bg-light"
                            />
                            {form.sentDate && (
                              <small className="text-muted d-block"></small>
                            )}
                          </CCol>
                        </CRow>

                        <CRow className="mt-3">
                          <CCol md={12} sm={12} xs={12}>
                            <CRow>
                              <CCol
                                md={2}
                                sm={4}
                                xs={6}
                                className="text-complet-checkbox"
                              >
                                <div className="form-check">
                                  <CFormLabel className="label-check-edit">
                                    Is Complete
                                  </CFormLabel>
                                  <input
                                    className="form-check-input"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "-20px",
                                    }}
                                    type="checkbox"
                                    checked={form.isComplete === "1"}
                                    disabled
                                    readOnly
                                  />
                                </div>
                              </CCol>

                              <CCol
                                md={2}
                                sm={4}
                                xs={6}
                                className="text-complet-checkbox"
                              >
                                <div className="form-check">
                                  <CFormLabel className="label-check-edit">
                                    Is Sent
                                  </CFormLabel>
                                  <input
                                    className="form-check-input"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "-20px",
                                    }}
                                    type="checkbox"
                                    checked={form.isSent === "1"}
                                    disabled
                                    readOnly
                                  />
                                </div>
                              </CCol>

                              <CCol
                                md={2}
                                sm={4}
                                xs={6}
                                className="text-complet-checkbox"
                              >
                                <div className="form-check">
                                  <CFormLabel className="label-check-edit">
                                    Is Returned
                                  </CFormLabel>
                                  <input
                                    className="form-check-input"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "-20px",
                                    }}
                                    type="checkbox"
                                    checked={form.isReturn === "1"}
                                    disabled
                                    readOnly
                                  />
                                </div>
                              </CCol>

                              <CCol
                                md={2}
                                sm={4}
                                xs={6}
                                className="text-complet-checkbox"
                              >
                                <div className="form-check">
                                  <CFormLabel className="label-check-edit">
                                    Is Received
                                  </CFormLabel>
                                  <input
                                    className="form-check-input"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "-20px",
                                    }}
                                    type="checkbox"
                                    checked={form.isReceived === "1"}
                                    disabled
                                    readOnly
                                  />
                                </div>
                              </CCol>
                            </CRow>
                          </CCol>
                        </CRow>
                      </div>
                    );
                  })}

                  <CRow className="mt-3">
                    <CCol md={8} sm={12} xs={12}></CCol>
                    <CCol lg={3} md={12} sm={12} xs={12}>
                      <CFormLabel htmlFor="validationCustom03">
                        Total Charges :
                      </CFormLabel>
                      <CFormInput
                        type="number"
                        id="validationCustom03"
                        disabled
                        className="bg-light"
                        name="total_number"
                        value={chargestotal}
                        placeholder="Total"
                      />
                    </CCol>
                  </CRow>

                  <CRow className="mt-3">
                    <CForm>
                      <CCol md={8} sm={12} xs={12}>
                        <CFormLabel htmlFor="exampleFormControlTextarea1">
                          Note
                        </CFormLabel>
                        <CFormTextarea
                          id="exampleFormControlTextarea1"
                          name="note"
                          rows={3}
                          text=""
                          disabled
                          className="bg-light"
                          onChange={(e) => setNote(e.target.value)}
                          value={note}
                        ></CFormTextarea>
                      </CCol>
                    </CForm>
                  </CRow>

                  <CRow className="mt-3">
                    <CCol md={7} sm={12} xs={12}>
                      <CFormLabel htmlFor="validationCustom02">
                        {OrderPhoto &&
                          OrderPhoto != "" &&
                          OrderPhoto != "No Image"
                          ? "Order Image"
                          : ""}
                      </CFormLabel>
                    </CCol>
                  </CRow>
                  <CCol xs={12}>
                    {preview ? (
                      <img
                        src={preview}
                        className="imagePreview"
                        alt="Preview"
                      />
                    ) : OrderPhoto &&
                      OrderPhoto != "" &&
                      OrderPhoto != "No Image" ? (
                      <img
                        src={OrderPhoto}
                        className="imagePreview"
                        alt="Order"
                      />
                    ) : null}
                  </CCol>
                </CForm>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}

export default View;
